import recentPayments from '../data/recentPayments/recentPayments.json';

export const getAllTableData = (persona: any) => {
    const data: any = recentPayments['data'];

    return data[persona];
};
